import { onCLS, onINP, onLCP, onFCP, onTTFB, type Metric } from 'web-vitals';
import * as Sentry from '@sentry/react';

// Per plan §6.4 / web/performance.md: LCP < 2.5s, INP < 200ms, CLS < 0.1.
// Web Vitals collected from real users, forwarded to Sentry performance and
// (post-Sprint-3) the first-party events table for the cost-aware dashboard.

const WARN_THRESHOLDS: Record<string, number> = {
  LCP: 2_500,
  INP: 200,
  CLS: 0.1,
  FCP: 1_500,
  TTFB: 800,
};

function report(metric: Metric): void {
  const threshold = WARN_THRESHOLDS[metric.name];
  const isPoor = threshold !== undefined && metric.value > threshold;

  if (import.meta.env.PROD) {
    Sentry.captureMessage(`web-vitals.${metric.name}`, {
      level: isPoor ? 'warning' : 'info',
      tags: { vital: metric.name, rating: metric.rating },
      extra: {
        value: metric.value,
        delta: metric.delta,
        id: metric.id,
        navigationType: metric.navigationType,
      },
    });
  } else if (isPoor) {
    // eslint-disable-next-line no-console
    console.warn(
      `[web-vitals] ${metric.name} = ${metric.value.toFixed(2)} (target < ${threshold})`,
    );
  }
}

export function initWebVitals(): void {
  onCLS(report);
  onINP(report);
  onLCP(report);
  onFCP(report);
  onTTFB(report);
}
